module.exports = __webpack_public_path__ + "img/41_52.443506ff.png";